export default __webpack_public_path__ + "static/am-hero_graphic-f9d50efd4cfd64e6d9e7a30170ea8dc2.svg";